module.exports = __webpack_public_path__ + "static/img/wxtp_20260714114139_102_157.c7aacd3.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/news/20260714/wxtp_20260714114139_102_157.jpg
// module id = JJca
// module chunks = 0